import { FC, useState } from "react";

import styles from "./sidebarFilterMenu.module.scss";

type TSidebarFilterMenuProps = {
    extraClassName?: string,
    selectedFilterName?: string;
    children: (null | JSX.Element)[];
};

export const SidebarFilterMenu: FC<TSidebarFilterMenuProps> = ({ extraClassName, children, selectedFilterName }: TSidebarFilterMenuProps) => {

    children = children.filter((child) => child && "title" in child.props);
    const childTitles = children.map((child) => child?.props.title);
    const [selectedButtonType, setSelectedButtonType] = useState(selectedFilterName && selectedFilterName in childTitles ? selectedFilterName : children[0]?.props.typeName);

    let currentlyMappedChild: JSX.Element | undefined;
    children.forEach(child => {
        if(!child) return;
        if(child.props.typeName === selectedButtonType) {
            currentlyMappedChild = child;
        }
    });

    const getClassName = (): string => {
        const classNameList = [styles.sidebarFilterMenu];
        if(extraClassName) classNameList.push(extraClassName);
        const className = classNameList.join(" ");                
        return className;
    };

    return (
        <>
            <div className={getClassName()}>
                {
                    children.map((child, index) => {
                        if(!child) return null;
                        return (
                            <button key={index} className={`${child.props.typeName === selectedButtonType ? styles.active: "" }`}
                                onClick={() => { setSelectedButtonType(child.props.typeName); }}
                            >
                                {child.props.title}
                            </button>
                        );
                    })
                }
            </div>

            <div style={{width: "100%"}}>
                {currentlyMappedChild ? currentlyMappedChild : <></>}
            </div>
        </>
    );
};